import fetch from 'auth/FetchInterceptor'
import {API_BASE_URL} from '../configs/AppConfig'
const CoachService = {}


CoachService.getCoach = function (params) {
	let {page, searchCoach} = params;
	let offset = (page-1)*10;
	return fetch({
		url: API_BASE_URL+'/v1/admin/all-coach',
		method: 'get',
        params: {
            'offset' : offset,
			searchCoach
        }
	})
}; 

CoachService.getCoachWithId = function (id) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/single-coach/${id}`,
		method: 'get',

	})
};

CoachService.getCoachGroup = function (data) {
	let {id, page} = data;

   let offset = (page-1)*10;
  return fetch({
	  url: API_BASE_URL+`/v1/admin/coach-group/${id}`,
	  method: 'get',
	  params: {
		  'offset' : offset
	  }
  })
};

CoachService.getCoachSession = function (data) {
	let {id, page} = data;

   let offset = (page-1)*10;
  return fetch({
	  url: API_BASE_URL+`/v1/admin/coach-session/${id}`,
	  method: 'get',
	  params: {
		  'offset' : offset
	  }
  })
};

CoachService.getCoachPlayer = function (data) {
	let {id, page} = data;

   let offset = (page-1)*10;
  return fetch({
	  url: API_BASE_URL+`/v1/admin/coach-player/${id}`,
	  method: 'get',
	  params: {
		  'offset' : offset
	  }
  })
};

CoachService.createCoach = function (data) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/create-new-coach`,
		method: 'post',
        data: data

	})
};

CoachService.getAllSports = function (data) {

  return fetch({
	  url: API_BASE_URL+`/v1/admin/get-all-sport`,
	  method: 'get',
	  
  })
};

CoachService.getAllClub = function (data) {
	
	return fetch({
		url: API_BASE_URL+`/v1/admin/get-all-club`,
		method: 'get',
		
	})
  };

  CoachService.trialCoach = function (data) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/update-trial-coach`,
		method: 'post',
        data: data

	})
};

CoachService.deleteCoach = function (data) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/delete-coach`,
		method: 'post',
		data:data
	})
};

CoachService.updateCoach = function (data) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/edit-coach`,
		method: 'post',
		data: data

	})
}


export default CoachService;